import * as styleguide from "@toolkit/Themes/common/styleguide";

export default styleguide;
